// src/Authentication/ResetPassword.js

import React, { useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import "./Auth.css";

const API = process.env.REACT_APP_API_URL;

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [data, setData] = useState({
    email: location.state?.email || "",
    otp: "",
    newPassword: ""
  });

  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!data.otp || !data.newPassword) {
      alert("Please fill all fields!");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(
        `${API}/auth/reset-password-otp`,
        data
      );

      alert(res.data.message);
      navigate("/login");

    } catch (error) {
      console.log(error.response?.data);
      alert(error.response?.data?.error || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <h2>Reset Password</h2>

      <input
        placeholder="Email"
        value={data.email}
        readOnly
      />

      <input
        placeholder="OTP"
        value={data.otp}
        onChange={(e) => setData({ ...data, otp: e.target.value })}
      />

      <input
        type="password"
        placeholder="New Password"
        value={data.newPassword}
        onChange={(e) => setData({ ...data, newPassword: e.target.value })}
      />

      <button onClick={handleSubmit} disabled={loading}>
        {loading ? "Resetting..." : "Reset Password"}
      </button>
    </div>
  );
};

export default ResetPassword;